import * as PropTypes from "prop-types";

const ComponentWithFallback = props =>
  !props.useFallbackComponent ? props.children : props.fallbackComponent;

ComponentWithFallback.propTypes = {
  useFallbackComponent: PropTypes.bool,
  children: PropTypes.element.isRequired,
  fallbackComponent: PropTypes.element
};

export default ComponentWithFallback;
